import UserForm from '../UserForm/UserForm'


const UserSignUp = () => {
	return (
		<UserForm formType={'signup'} />
	)
}

export default UserSignUp